export default __webpack_public_path__ + "static/media/Close.2d48127c.svg";